import { createApp } from 'vue';
import { createGtm } from '@gtm-support/vue-gtm';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import PrimeVue from 'primevue/config';
import VueCookies from 'vue-cookies';
import Skeleton from 'primevue/skeleton';

import App from './App.vue';
import './newrelic';
import router from './router';
import './services/axios';

import StickyDirective from './directives/stickyMenu';
import SkeletonDirective from './directives/skeleton';

import 'primevue/resources/themes/tailwind-light/theme.css';
import 'primevue/resources/primevue.min.css';
import Tooltip from 'primevue/tooltip';
import 'primeicons/primeicons.css';
import ToastService from 'primevue/toastservice';

// https://vue3datepicker.com/
import VueDatePicker from '@vuepic/vue-datepicker';
import VueApexCharts from 'vue3-apexcharts';
import '@vuepic/vue-datepicker/dist/main.css';

import './assets/css/global.scss';
import './assets/css/fonts.css';
import vue3GoogleLogin from 'vue3-google-login';
import hljs from 'highlight.js';
import CodeEditor from 'simple-code-editor';

import { createI18n } from 'vue-i18n';
import messages from '@intlify/unplugin-vue-i18n/messages';
import { useAuthStore } from '@/store/global/auth';

import { plugin, defaultConfig } from '@formkit/vue'
import '@formkit/themes/genesis';

import { DSSChart, addDSSChartTranslations } from 'dsp-semactic';
import 'dsp-semactic/dist/dsp-semactic.css';

const app = createApp(App);

app.use(PrimeVue, { ripple: true });

app.config.errorHandler = (err, vm, info) => {
	console.group("Vue Error Handler");
	console.error("Error:", err);
	console.error("Vue component instance:", vm ? (vm.$options?.name || vm.$options?._componentTag || 'Anonymous') : 'No component instance');
	console.error("Additional info:", info);
	if (err.stack) {
		const stackLines = err.stack.split('\n');
		const relevantStack = stackLines.find(line => line.includes('.vue'));
		if (relevantStack) console.error("Relevant stack line:", relevantStack.trim());
	}
	console.groupEnd();
};

app.use(ToastService);

const pinia = createPinia();
app.use(pinia);
pinia.use(piniaPluginPersistedstate);

let user_locale = 'en';
const user = useAuthStore();
if (user.user && user.user.language) {
	user_locale = user.user.language;
}

const i18n = createI18n({
	locale: user_locale,
	useScope: 'global',
	messages,
});

addDSSChartTranslations(i18n);

app.use(i18n);

app.use(VueCookies);

app.use(vue3GoogleLogin, {
	clientId: '520677272714-r0bsqra5jrvqedpu38961ighuh3e1r47.apps.googleusercontent.com',
	clientSecret: '0-1-yNes73PeANEkwDPDEsS4',
});

// Workaround for Google Tag Manager looking for elements that may not exist and causing errors in the console.
const gtmMissingElements = new Set([
    '__gaOptOutExtension',
]);

const originalGetElementById = document.getElementById;
document.getElementById = function(id) {
    const element = originalGetElementById.call(document, id);
   
    if (!element && gtmMissingElements.has(id)) {
        const dummy = document.createElement('div');
        dummy.style.display = 'none';
        return dummy;
    }
   
    return element;
};

app.use(router);

app.use(createGtm({
	id: 'GTM-52N8B4F',
	vueRouter: router,
}));

app.component('VueDatePicker', VueDatePicker);
app.component('apexchart', VueApexCharts);
app.component('Skeleton', Skeleton);
app.component('code-editor', CodeEditor);

app.component('DSSChart', DSSChart);

app.use(plugin, defaultConfig);

app.directive('tooltip', Tooltip);
app.use(StickyDirective);
app.use(SkeletonDirective);

app.mount('#app');